import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import { RollingLoader, ToggleSwitch } from "../../../components/commons";
import { returnInputFieldLength } from "../../../utils/commonFunctions";
import Select from "react-select";
import { SelectOptionType } from "../../../redux/scheduling/schedulingTypes";

type AppProps = {
  showAddEditOpenPositionModal: boolean;
  isEdit: boolean;
  handleAddOpenPosition: () => void;
  handlePositionNameChange: (data: any) => void;
  toggleAddEditOpenPositionModal: () => void;
  positionName: string;
  positionNameError: string;
  handleToogleStatusChange: () => void;
  status: boolean;
  finalUsersDepartmentList: any;
  department: SelectOptionType;
  handleDepartmentChange: (data: SelectOptionType) => void;
  usersDepartmentFetching: boolean;
  setUsersDepartmentOffset: React.Dispatch<React.SetStateAction<number>>;
  setUsersDepartmentText: React.Dispatch<React.SetStateAction<string>>;
  departmentLimit: number;
  uniqueCheckMessage:string;
  uniqueCheckFetching:boolean;
};

const AddEditOpenPosition = ({
  showAddEditOpenPositionModal,
  toggleAddEditOpenPositionModal,
  isEdit,
  positionName,
  positionNameError,
  handleAddOpenPosition,
  handlePositionNameChange,
  handleToogleStatusChange,
  finalUsersDepartmentList,
  department,
  handleDepartmentChange,
  usersDepartmentFetching,
  setUsersDepartmentOffset,
  setUsersDepartmentText,
  departmentLimit,
  uniqueCheckMessage,

uniqueCheckFetching,
  status,
}: AppProps) => {
  const checkUsersDepartmentBottom = () => {
    setUsersDepartmentOffset((prv: any) => prv + departmentLimit);
  };
  return (
    <Modal
      isOpen={showAddEditOpenPositionModal}
      toggle={toggleAddEditOpenPositionModal}
    >
      <ModalHeader className="pt-4 pl-4">
        {`${isEdit ? "Edit" : "Add"} Open Position`}
      </ModalHeader>
      <ModalBody className="pl-4 pr-4">
        <form>
          <div className="form-group mt-3">
            <div>
              <label
                htmlFor="foldername"
                className={positionName ? "active" : ""}
              >
                Enter Position Name <span className="color-red">*</span>
              </label>
              <div className="d-flex flex-row position-relative">
                <input
                  type="text"
                  className={`form-control ${
                    !!positionNameError ? "error-border" : null
                  }`}
                  name="text"
                  value={positionName}
                  autoFocus
                  onChange={(e) => handlePositionNameChange(e)}
                  maxLength={60}
                  onKeyPress={(e: any) =>
                    e.key === "Enter" ? handleAddOpenPosition() : null
                  }
                />
              {uniqueCheckFetching && <RollingLoader />}

              </div>
              {positionName?.trim().length && uniqueCheckMessage?.includes("already exists") ?
                                <small className="text-danger">
                                    Position Name is already in use!
                                </small> : ""
                            }
              {!!positionNameError && (
                <small className="text-danger">{positionNameError}</small>
              )}
            </div>
            <span className="input-length">
              {returnInputFieldLength(positionName?.length, 60)}
            </span>
          </div>
          <div className="col-md-6 d-flex flex-column p-0">
            <label htmlFor="department">Department <span className="color-red">*</span></label>
            <div className="mt-1">
              <Select
                options={
                  finalUsersDepartmentList?.length > 0
                    ? [
                        ...finalUsersDepartmentList,
                      ]
                    : []
                }
                value={department}
                onChange={(department: any) =>
                  handleDepartmentChange(department)
                }
                isSearchable={true}
                isLoading={usersDepartmentFetching}
                onMenuClose={() => setUsersDepartmentOffset?.(0)}
                onMenuScrollToBottom={checkUsersDepartmentBottom}
                onInputChange={(e) => {
                  setUsersDepartmentText?.(e);
                  setUsersDepartmentOffset?.(0);
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4 form-group mt-3">
              <label htmlFor=" Status" className="">
                Status
              </label>
              <ToggleSwitch
                handleToggleChange={() => handleToogleStatusChange()}
                isChecked={status}
              />
            </div>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <span className="pointer" onClick={toggleAddEditOpenPositionModal}>
          Cancel
        </span>
        <Button
          color="primary ml-3"
          onClick={() => {
            handleAddOpenPosition();
            toggleAddEditOpenPositionModal();
          }}
          disabled={positionName?.trim().length === 0 || uniqueCheckMessage?.includes("already exists") || !department?.value}
        >
          {isEdit ? "Update Open Position" : "Add Open Position"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddEditOpenPosition;
